// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CheckCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/CheckCircleTwoTone";
import AntdIcon from '../components/AntdIcon';

var CheckCircleTwoTone = function CheckCircleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CheckCircleTwoToneSvg
  }));
};

CheckCircleTwoTone.displayName = 'CheckCircleTwoTone';
export default React.forwardRef(CheckCircleTwoTone);